import React, { useState, useEffect, Fragment } from 'react';
import { useSelector } from 'react-redux';
import {
  Label,
  Card,
  CardBody,
  CardImg,
  ButtonGroup,
  Button,
  Row,
  Modal,
  ModalHeader,
  InputGroupAddon,
  InputGroupText,
  Input,
  ModalBody,
  InputGroup,
  CustomInput,
  Collapse,
  Tooltip,
} from 'reactstrap';
import Select from 'react-select';
import { ChromePicker } from 'react-color'
import {
  Separator,
  Colxx,
} from '../../../../../../components/common/CustomBootstrap';
import {
  colorBlockStlye,
  editingStlyeWithoutBackGround,
  SelectStyle,
  InputStlye,
  AvatarSizeStyle,
  setBackGroundColor,
} from '../../style/DigitalAssistantStyle';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import avatars from '../../data/avatarData';
//import Avatar from './Avatar';
import ImageGallery from '../../../propinfo/gallery/index';
import IconGallery from '../../../propinfo/icon-gallery';
import { getGroupID } from '../../../../../../helpers/AxiosAPI';
import { string } from 'prop-types';
import FontsList from '../FontsList';
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
};

const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];
export default function HelpCenterDigitalAssistant({
  isVoucher = false,
  botSettings,
  allProperties,
  integrationProperties,
  saveIntegration,
  integrationId,
  locale,
  menuItems = [],
  conversationFlowList = []
}) {
  const propertyId = useSelector((state) => state?.settings?.propertyId);
  /** Avatar state */
  // const [isSelected, setIsSelected] = useState({
  //   Jenni: false,
  //   Novi: false,
  //   Bob: false,
  //   Sarah: false,
  //   Wallis: false,
  // });;
  const [formatedProperties, setFormatedProperties] = useState([]);
  const [collapse, setCollapse] = useState("widgetTheme");
  const [avatarLink, setAvatarLink] = useState('');
  const [desktopIcon, setDesktopIcon] = useState('');
  const [voiceIcon, setVoiceIcon] = useState('');
  //const [avatarName, setAvatarName] = useState('');
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  /** other Digital Assistant state */
  const [edit, setEdit] = useState(true);
  const [setting, setSetting] = useState(botSettings);
  const [selectedProperties, setSelectedProperties] = useState([]);
  const [error, setError] = useState(true);
  const [fontsList, setFontsList] = useState({
    'title': '',
    'subTitle': '',
    'serviceTitle': '',
    'serviceDescription': '',
    'website': '',
    'buttonText': '',
    'voucherTitle': '',
    'voucherDescription': '',
  });
  const [desktopAvatar, setDesktopAvatar] = useState('');
  const [mobileAvatar, setMobileAvatar] = useState('');
  const [widgetLayout, setWidgetLayout] = useState('Rounded');
  const [widgetTheme, setWidgetTheme] = useState('WebWidgetMenus');
  const [desktopGalleryVisible, setDesktopGalleryVisible] = useState(false);
  const [voiceGalleryVisible, setVoiceGalleryVisible] = useState(false);
  const [isFooterHide, setIsFooterHide] = useState(botSettings.isFooterHide !== undefined ? botSettings.isFooterHide : false);
  const [isShowBot, setIsShowBot] = useState(botSettings.isShowChatbot !== undefined ? botSettings.isShowChatbot : false);
  const [assistantDetail, setAssistantDetail] = useState([]);
  const [propertyButtonsData, setPropertyButtonsData] = useState({});
  const [selectedPropertyId, setSelectedPropertyId] = useState("default");
  const [suggestionBot, setsuggestionBot] = useState({
    message: [{ statement: "How can I help?", locale: locale }],
    buttons: [{
      text: '',
      subTitle: '',
      value: '',
      actionType: 'SendToChatBot',
      locale: locale,
    }],
    placeHolderText: [{ statement: "Ask me anything about the hotel...", locale: locale }],
    backgroundImage: '',
  });
  const [suggestionGalleryVisible, setSuggestionGalleryVisible] = useState(false);

  const toggleSuggestionGallery = () => {
    setSuggestionGalleryVisible(!suggestionGalleryVisible);
  };

  const selectedSuggestionImage = (image) => {
    if (image !== undefined) {
      setsuggestionBot((prev) => ({ ...prev, backgroundImage: image.src }));
    }
  };

  const handleRemoveSuggestionImage = () => {
    setsuggestionBot((prev) => ({ ...prev, backgroundImage: '' }));
  };

  let [iseditMode, setEditMode] = useState({
    'botBackground': false,
    'buttonColor': false,
    'buttonTextColor': false,
    'FrameColor': false,
    'micColor': false
  });
  useEffect(() => {

    if (botSettings) {
      setSetting(botSettings);
      //setAvatarName(botSettings.name);
      setAvatarLink(botSettings.urls.icon);
      setDesktopIcon(botSettings.urls.desktopIcon);
      setDesktopAvatar(botSettings?.sizes?.desktopAvatar);
      setVoiceIcon(botSettings?.urls?.micIcon);
      setMobileAvatar(botSettings?.sizes?.mobileAvatar);
      setWidgetLayout(botSettings?.widgetLayout);
      setFontsList(botSettings.fonts);
      setWidgetTheme(botSettings?.theme);
      //setIsSelected({ ...avatars, [botSettings.name]: true });
      var assistantdata = botSettings.assistantDetails.filter(i => i.locale === locale);
      if (assistantdata.length > 0) {
        setAssistantDetail({
          name: assistantdata[0].name,
          title: assistantdata[0].title,
          subTitle: assistantdata[0].subTitle,
          locale: locale
        });
      } else {
        var assistantdataEn = botSettings.assistantDetails.filter(i => i.locale === "en");
        if (assistantdataEn.length > 0) {
          setAssistantDetail({
            name: assistantdataEn[0].name,
            title: assistantdataEn[0].title,
            subTitle: assistantdataEn[0].subTitle,
            locale: locale
          });
        }
      }
      var suggestionbotsetting = { ...suggestionBot };
      if (botSettings?.suggestionBotSetting?.buttons) {
        suggestionbotsetting.message = botSettings?.suggestionBotSetting?.message?.length
          ? botSettings.suggestionBotSetting.message
          : [{ statement: "How can I help?", locale }];
        ;
        suggestionbotsetting.placeHolderText = botSettings.suggestionBotSetting.placeHolderText?.length
          ? botSettings.suggestionBotSetting.placeHolderText
          : [{ statement: "Ask me anything about the hotel...", locale }];;
        suggestionbotsetting.backgroundImage = botSettings.suggestionBotSetting.backgroundImage || '';
      }
      if (botSettings.suggestionBotSetting.buttons !== null) {
        var buttons = botSettings.suggestionBotSetting.buttons.filter(i => i.locale === locale);
        if (buttons.length > 0) {
          suggestionbotsetting.buttons = buttons.map((b) => ({
            ...b,
            actionType: b.actionType || 'SendToChatBot',
            value: b.value || '',
          }));
        } else {
          var buttonsEn = botSettings.suggestionBotSetting.buttons.filter(i => i.locale === "en");
          if (buttonsEn.length > 0) {
            const dataEn = buttonsEn.map(i => ({
              text: i.text,
              subTitle: i.subTitle,
              value: i.value,
              actionType: i.actionType || 'SendToChatBot',
              locale: locale
            }));

            suggestionbotsetting.buttons = dataEn;
          }
        }
      }
      if (botSettings?.suggestionBotSetting?.propertyButtons) {
        const map = {};

        botSettings.suggestionBotSetting.propertyButtons.forEach(p => {

          const allButtons = p.buttons || [];
          let localeButtons = allButtons.filter(
            b => b.locale === locale || !b.locale
          );

          if (!localeButtons.length) {
            const enButtons = allButtons.filter(
              b => b.locale === "en" || !b.locale
            );

            localeButtons = enButtons.map(b => ({
              ...b,
              locale: locale
            }));
          }

          const validButtons = localeButtons
            .filter(b => b.text || b.subTitle || b.value)
            .map(b => ({
              ...b,
              actionType: b.actionType || "SendToChatBot",
              value: b.value || ""
            }));

          if (validButtons.length) {
            map[p.propertyId] = validButtons.length ? validButtons : [];
          }
        });

        setPropertyButtonsData(map);
      }
      setsuggestionBot(suggestionbotsetting);
    }
  }, [botSettings]);
  useEffect(() => {
    if (!propertyButtonsData || !formatedProperties?.length) return;

    const initial = Object.keys(propertyButtonsData)
      .map(pid => {
        const prop = formatedProperties.find(p => p.id === pid);
        return prop ? { label: prop.name, value: prop.id } : null;
      })
      .filter(Boolean);
    setSelectedProperties(initial);
  }, [propertyButtonsData, formatedProperties]);

  useEffect(() => {
    const result = integrationProperties.map(id => {
      return allProperties.find(elem => elem.id === id);
    });
    setFormatedProperties(sortPropertyListByName(result));
  }, [integrationProperties, allProperties]);

  useEffect(() => {
    if (setting) {
      setSetting(prev => ({
        ...prev,
        sizes: {
          ...prev?.sizes,
          desktopAvatar,
          mobileAvatar
        },
        urls: {
          ...prev?.urls,
          icon: avatarLink,
          desktopIcon,
          micIcon: voiceIcon
        }
      }));
    }
  }, [avatarLink, desktopIcon, desktopAvatar, mobileAvatar, voiceIcon]);
  const propertyOptions = (formatedProperties || []).map(p => ({
    label: p.name,
    value: p.id
  }));
  const setCollasp = (e) => {
    if (collapse === e) {
      setCollapse("");
    }
    else {
      setCollapse(e);
    }
  };

  const handleAvatarSizeChange = (e, type) => {
    const value = e.target.value;
    if (type === 'desktop') {
      setDesktopAvatar(value);
    } else if (type === 'mobile') {
      setMobileAvatar(value);
    }
  };
  const handleWidgetLayout = (e) => {

    const newLayout = e.target.value;
    setWidgetLayout(newLayout);
    setSetting(prevSetting => ({
      ...prevSetting,
      widgetLayout: newLayout,
    }));
  }
  const handleWidgetTheme = (e) => {

    const newTheme = e.target.value;
    if (e.target.value === "StraightChat") {
      setIsShowBot(true);
    }
    else {
      setIsShowBot(false);
    }
    setWidgetTheme(newTheme);
    setSetting(prevSetting => ({
      ...prevSetting,
      theme: newTheme,
    }));
  }
  const handleChange = (e) => {
    const value = e.target.value;
    setAssistantDetail({
      ...assistantDetail,
      [e.target.name]: value,
      locale: locale
    });
  };

  const handleSave = () => {
    setEdit(!edit);
    var existingDetail = setting.assistantDetails.filter(i => i.locale !== locale);
    var assitantdata = [...existingDetail, assistantDetail];
    setting.assistantDetails = assitantdata;
    setting.fonts = fontsList;
    setting.isFooterHide = isFooterHide;
    setting.isShowChatbot = isShowBot;
    var existButton = [...suggestionBot.buttons];
    if (setting.suggestionBotSetting.buttons !== null) {
      existButton = setting.suggestionBotSetting.buttons.filter(i => i.locale !== locale);
      if (suggestionBot.buttons.length > 0) {
        suggestionBot.buttons.map(elem => {
          existButton.push(elem);
        })
      }
    }
    const existingPropertyButtons = setting?.suggestionBotSetting?.propertyButtons || [];
    const propertyButtonsArray = Object.keys(propertyButtonsData).map(propertyId => {
      const existing = existingPropertyButtons?.find(p => p.propertyId === propertyId);

      let buttons = [];

      if (existing && existing.buttons) {
        buttons = existing.buttons.filter(b => b.locale !== locale);
      }
      const currentLocaleButtons = (propertyButtonsData[propertyId] || [])
        .filter(b => b.text || b.subTitle || b.value)
        .map(b => ({
          ...b,
          locale: locale
        }));

      buttons = [...buttons, ...currentLocaleButtons];
      if (!buttons.length) return null;

      return {
        propertyId,
        buttons
      };
    }).filter(Boolean);
    var suggestionbot = {
      message: suggestionBot.message,
      buttons: existButton,
      placeHolderText: suggestionBot.placeHolderText,
      backgroundImage: suggestionBot.backgroundImage || '',
      propertyButtons: propertyButtonsArray
    };
    setting.suggestionBotSetting = suggestionbot;
    saveIntegration({ botSetting: setting });
  };

  const getLocalStatement = (statements) => {
    if (statements !== undefined && statements !== null && statements.length > 0) {
      const index = statements.findIndex((m) => m.locale === locale);
      if (index === -1) {
        const englishIndex = statements.findIndex(
          (m) => m.locale === 'en'
        );
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      } else {
        return statements[index].statement;
      }
    } else {
      return '';
    }
  };
  const handleChangeCookiesText = (source, e) => {
    if (source === 'user') {
      if (setting.cookiesSetting !== null &&
        setting.cookiesSetting.text !== null && setting.cookiesSetting.text.length > 0) {
        const index = setting.cookiesSetting.text.findIndex((m) => m.locale === locale);
        var cookies = { ...setting.cookiesSetting };
        if (index === -1) {
          const newStatement = {
            statement: e,
            locale: locale,
          };
          cookies.text = [...cookies.text, newStatement];
          setSetting({
            ...setting,
            cookiesSetting: cookies,
          });
        } else {
          let newArr = [...cookies.text];
          newArr[index].statement = e;
          cookies.text = newArr;
          setSetting({
            ...setting,
            cookiesSetting: cookies,
          });
        }
      } else {
        var cookies = { ...setting.cookiesSetting };
        const newStatement = {
          statement: e,
          locale: locale,
        };
        var val = cookies.text !== null ? cookies.text : [];
        cookies.text = [...val, newStatement];
        setSetting({
          ...setting,
          cookiesSetting: cookies,
        });
      }
    }
  };
  const handleChangeCookies = (e) => {
    var cookies = { ...setting.cookiesSetting };
    cookies.isShowCookies = e.target.checked;
    setSetting({ ...setting, cookiesSetting: cookies });
  };
  const handleCheckedBookingButton = (e) => {
    setSetting({ ...setting, isBookingButtonHide: e.target.checked });
  }
  const handleCheckedGreyscaleButton = (e) => {
    setSetting({ ...setting, isGreyScale: e.target.checked });
  }
  const handleCheckedBookNowButton = (e) => {
    setSetting({ ...setting, isBookNowButton: e.target.checked });
  }
  const handleChangeBookNowButtonText = (e) => {
    setSetting({ ...setting, [e.target.name]: e.target.value });
  }
  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };
  const toggledesktopgallery = () => {
    setDesktopGalleryVisible(!desktopGalleryVisible);
  };
  const selectedImage = (image) => {
    if (image !== undefined) {
      setAvatarLink(image.src);
    }
  };
  const selectedDesktopImage = (image) => {
    if (image !== undefined) {
      setDesktopIcon(image.src);
    }
  };
  const handleCheckedMicIcon = (e) => {
    setSetting({ ...setting, isMicIcon: e.target.checked });
  }

  const toggleVoicegallery = () => {
    setVoiceGalleryVisible(!voiceGalleryVisible);
  };
  const selectedVoiceIcon = (image) => {
    if (image !== undefined) {
      setVoiceIcon(image.src);
    }
  };
  const SetClose = () => {
    setEditMode({
      'botBackground': false,
      'buttonColor': false,
      'buttonTextColor': false,
      'FrameColor': false,
      'micColor': false
    });
  };
  const CloseColorBox = (event) => {
    if ((iseditMode.botBackground === true ||
      iseditMode.buttonColor === true ||
      iseditMode.buttonTextColor === true ||
      iseditMode.FrameColor === true ||
      iseditMode.micColor === true)) {
      SetClose();
    }
  };

  const handleSuggestionTextChange = (e) => {
    if (suggestionBot.message !== undefined && suggestionBot.message !== null && suggestionBot.message.length > 0) {
      const index = suggestionBot.message.findIndex((m) => m.locale === locale);
      var cookies = [...suggestionBot.message];
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          locale: locale,
        };
        cookies = [...suggestionBot.message, newStatement];
        setsuggestionBot({ ...suggestionBot, message: cookies });
      } else {
        let newArr = [...suggestionBot.message];
        newArr[index].statement = e.target.value;
        cookies = newArr;
        setsuggestionBot({ ...suggestionBot, message: cookies });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        locale: locale,
      };
      var val = suggestionBot.message !== null ? suggestionBot.message : [];
      var cookies = [...val, newStatement];
      setsuggestionBot({ ...suggestionBot, message: cookies });
    }
  }
  const handleSuggestionPlaceholderTextChange = (e) => {
    if (suggestionBot.placeHolderText !== undefined && suggestionBot.placeHolderText !== null && suggestionBot.placeHolderText.length > 0) {
      const index = suggestionBot.placeHolderText.findIndex((m) => m.locale === locale);
      var cookies = [...suggestionBot.placeHolderText];
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          locale: locale,
        };
        cookies = [...suggestionBot.placeHolderText, newStatement];
        setsuggestionBot({ ...suggestionBot, placeHolderText: cookies });
      } else {
        let newArr = [...suggestionBot.placeHolderText];
        newArr[index].statement = e.target.value;
        cookies = newArr;
        setsuggestionBot({ ...suggestionBot, placeHolderText: cookies });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        locale: locale,
      };
      var val = suggestionBot.placeHolderText !== undefined && suggestionBot.placeHolderText !== null ? suggestionBot.placeHolderText : [];
      var cookies = [...val, newStatement];
      setsuggestionBot({ ...suggestionBot, placeHolderText: cookies });
    }
  }


  // const handleActionValueChange = (index, value) => {
  //   const values = [...suggestionBot.buttons];

  //   console.log("Before Action Value Change:", values[index]);
  //   values[index].value = value;
  //   console.log("After Action Value Change:", values[index]);
  //   setsuggestionBot({ ...suggestionBot, buttons: values });
  // };

  // const renderActionValueField = (nudge, index) => {
  //   // Default: keep existing behavior for unclear requirement(s)
  //   if (nudge.actionType === 'OPEN_URL') {
  //     return (
  //       <Colxx sm={5} className="mb-3">
  //         <Label>Open URL</Label>
  //         <Input
  //           type="text"
  //           name="value"
  //           value={nudge.value}
  //           onChange={(e) => handleActionValueChange(index, e.target.value)}
  //           placeholder="URL"
  //         />
  //       </Colxx>
  //     );
  //   }
  //   if (nudge.actionType === 'OPEN_WIDGET_MENU') {
  //     return (
  //       <Colxx sm={5} className="mb-3">
  //         <Label>Menu Item</Label>
  //         <Input
  //           type="select"
  //           name="value"
  //           value={nudge.value || ''}
  //           onChange={(e) => handleActionValueChange(index, e.target.value)}
  //         >
  //           <option value="">Select</option>
  //           {menuItems.map((m) => (
  //             <option key={m.id} value={m.id}>
  //               {m.title}
  //             </option>
  //           ))}
  //         </Input>
  //       </Colxx>
  //     );
  //   }
  //   if (nudge.actionType === 'STATIC_FLOW') {
  //     return (
  //       <Colxx sm={5} className="mb-3">
  //         <Label>Conversation Flow</Label>
  //         <Input
  //           type="select"
  //           name="value"
  //           value={nudge.value || ''}
  //           onChange={(e) => handleActionValueChange(index, e.target.value)}
  //         >
  //           <option value="">Select</option>
  //           {conversationFlowList.map((item) => (
  //             <option key={item.id} value={item.id}>
  //               {item.name}
  //             </option>
  //           ))}
  //         </Input>
  //       </Colxx>
  //     );
  //   }
  //   return null;

  // };

  const ImageMicIconButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={voiceGalleryVisible}
                toggle={toggleVoicegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={toggleVoicegallery}>Select Image</ModalHeader>
                <ModalBody>
                  <IconGallery
                    selectedSvg={selectedVoiceIcon}
                    togglegallery={toggleVoicegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>Select Avatar</ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={'avatar'}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const ImageDesktopGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={desktopGalleryVisible}
                toggle={toggledesktopgallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={toggledesktopgallery}>Select Image</ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedDesktopImage}
                    togglegallery={toggledesktopgallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  const renderButtonsSection = (buttons = [], setButtons) => {
    if (!Array.isArray(buttons)) buttons = [];

    const updateField = (index, field, value) => {
      const updated = buttons.map((btn, i) =>
        i === index ? { ...btn, [field]: value } : btn
      );
      setButtons(updated);
    };

    const handleActionTypeChange = (index, actionType) => {
      const updated = buttons.map((btn, i) =>
        i === index
          ? {
            ...btn,
            actionType,
            value: ''
          }
          : btn
      );
      setButtons(updated);
    };

    return (
      <>
        {buttons.length > 0 && <Separator className="mb-2" />}

        {buttons.map((nudge, index) => (
          <Fragment key={index}>
            <Row>

              <Colxx sm={6} className="mb-3">
                <Label>Title</Label>
                <Input
                  type="text"
                  value={nudge.subTitle}
                  onChange={(e) =>
                    updateField(index, 'subTitle', e.target.value)
                  }
                />
              </Colxx>

              <Colxx sm={5} className="mb-3">
                <Label>Sub Title</Label>
                <Input
                  type="text"
                  value={nudge.text}
                  onChange={(e) =>
                    updateField(index, 'text', e.target.value)
                  }
                />
              </Colxx>

              <Colxx sm={6} className="mb-3">
                <Label>Action Type</Label>
                <Input
                  type="select"
                  value={nudge.actionType || 'SendToChatBot'}
                  onChange={(e) =>
                    handleActionTypeChange(index, e.target.value)
                  }
                >
                  <option value="SendToChatBot">Send to Chatbot</option>
                  <option value="OPEN_WIDGET_MENU">Open Web Widget Menu</option>
                  <option value="OPEN_URL">Open URL</option>
                  <option value="STATIC_FLOW">Trigger Static Conversation Flow</option>
                  <option value="PROPERTY_LIST">Show Property List</option>
                </Input>
              </Colxx>

              {nudge.actionType === 'OPEN_URL' && (
                <Colxx sm={5} className="mb-3">
                  <Label>Open URL</Label>
                  <Input
                    type="text"
                    value={nudge.value}
                    onChange={(e) =>
                      updateField(index, 'value', e.target.value)
                    }
                  />
                </Colxx>
              )}

              {nudge.actionType === 'OPEN_WIDGET_MENU' && (
                <Colxx sm={5} className="mb-3">
                  <Label>Menu Item</Label>
                  <Input
                    type="select"
                    value={nudge.value || ''}
                    onChange={(e) =>
                      updateField(index, 'value', e.target.value)
                    }
                  >
                    <option value="">Select</option>
                    {menuItems.map((m) => (
                      <option key={m.id} value={m.id}>
                        {m.title}
                      </option>
                    ))}
                  </Input>
                </Colxx>
              )}

              {nudge.actionType === 'STATIC_FLOW' && (
                <Colxx sm={5} className="mb-3">
                  <Label>Conversation Flow</Label>
                  <Input
                    type="select"
                    value={nudge.value || ''}
                    onChange={(e) =>
                      updateField(index, 'value', e.target.value)
                    }
                  >
                    <option value="">Select</option>
                    {conversationFlowList.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Input>
                </Colxx>
              )}

              {nudge.actionType === 'SendToChatBot' && (
                <Colxx sm={5} className="mb-3">
                  <Label>Chatbot Message</Label>
                  <Input
                    type="text"
                    value={nudge.value}
                    onChange={(e) =>
                      updateField(index, 'value', e.target.value)
                    }
                  />
                </Colxx>
              )}

              <Colxx
                sm={1}
                className="mb-3"
                style={{
                  marginTop: "-37px",
                  ...(nudge.actionType === "PROPERTY_LIST" && {
                    marginLeft: "21.3rem"
                  })

                }}
              >
                <Label style={{ marginLeft: '-5px' }}>Remove</Label>
                <div>
                  <Button
                    onClick={() => {
                      const updated = buttons.filter((_, i) => i !== index);
                      setButtons(updated);
                    }}
                    size="xs"
                  >
                    -
                  </Button>
                </div>
              </Colxx>

            </Row>

            <Separator className="my-3" />
          </Fragment >
        ))
        }

        <Button
          className="mb-2 mt-2 ml-4"
          onClick={() =>
            setButtons([
              ...buttons,
              {
                text: '',
                subTitle: '',
                value: '',
                actionType: 'SendToChatBot',
                locale: locale
              }
            ])
          }
          size="xs"
        >
          + Add Button
        </Button>
      </>
    );
  };
  //console.log(setting);
  return (
    <Fragment>
      {setting ? (
        <Card>
          <CardBody name="bodyClick" onClick={(e) => { CloseColorBox(e); }}>
            <div className="text-center">
              <h6>Website Widget Appearance</h6>
            </div>
            <Separator className="mb-3" />

            <div className=''>
              <div className='collapse-btn border mt-0'
                onClick={() => setCollasp("widgetTheme")}
                aria-expanded={collapse === "widgetTheme"}>

                <h6>Widget Theme
                  <i className='simple-icon-arrow-down ml-1' />
                </h6>
              </div>
              <div className="text-center">
                <Collapse className="border " isOpen={collapse === "widgetTheme"}>
                  <div className="row mb-2 mt-4 text-center " style={{ margin: '0px 40px' }}>

                    <div className=" text-center col-md-12 mb-1">
                      <div className=''>
                        <b>Widget Theme</b>
                        <br />
                        <select
                          name="theme"
                          type='select'
                          style={SelectStyle}

                          value={widgetTheme}
                          onChange={(e) => handleWidgetTheme(e)}
                        >
                          <option value='WebWidgetMenus' >Web Widget with Menus (Standard Size)</option>
                          <option value='WebWidgetMenusFull' >Web Widget with Menus (Large Size)</option>
                          <option value='ChatSuggestions'>Web Widget with Suggested Questions</option>
                          <option value='ChatSuggestionsFull'>Full Screen with Suggested Questions</option>
                          <option value='StraightChat'>Web Widget Straight to Chat</option>
                          <option value='StraightChatFull'>Full Screen Straight to Chat</option>
                          <option value='StraightChatLarge' >Straight to Chat (Large Size)</option>
                        </select>
                        <p><span style={{ color: '#A9A9A9' }}>Default: Web Widget with Menus</span></p>


                      </div>
                    </div>
                    <div className=" text-center col-md-6 mb-1">
                      {setting.fonts !== undefined && (
                        <div className=''>
                          <b>Widget Layout</b>
                          <br />
                          <select
                            name="Widget Layout"
                            type='select'
                            style={SelectStyle}

                            value={widgetLayout}
                            onChange={(e) => handleWidgetLayout(e)}
                          >

                            <option value='Rounded' > Rounded </option>

                            <option value='Square Edges'>Square Edges </option>
                          </select>
                          <p><span style={{ color: '#A9A9A9' }}>Default: Rounded</span></p>


                        </div>
                      )}
                    </div>
                    <div className=" text-center col-md-6 mb-1">
                      {setting.fonts !== undefined && (
                        <div className=''>

                          <b>Website Font Name </b>

                          <br />
                          <div className="">
                            <FontsList InputStlye={SelectStyle} value={setting.fonts.website} settings={setting} setFont={(e) => setFontsList({ ...fontsList, website: e.target.value })}></FontsList>
                          </div>
                        </div>

                      )}
                    </div>
                  </div>
                  <div className="text-left">
                    <div style={{ padding: '0 5%' }}>
                      <Row>
                        <Colxx xxs="6">
                          <div>
                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                              <div className='col-md-6 text-left' style={{ marginTop: '0.30rem' }}>
                                <span className=''>Frame Color</span>
                              </div>
                              <div className='col-md-6'>
                                <InputGroup>
                                  <Input
                                    className=""
                                    type="text"
                                    onChange={(e) => {
                                      let colours = setting.colours;
                                      colours.frameColor = e.target.value;
                                      setSetting({ ...setting, colours: colours });
                                    }}
                                    value={setting.colours.frameColor}
                                  />
                                  <InputGroupAddon addonType="append">
                                    <InputGroupText onClick={() => {
                                      setEditMode({ ...iseditMode, FrameColor: !iseditMode.FrameColor });
                                    }
                                    } className="color-square" style={setBackGroundColor(setting.colours.frameColor)}></InputGroupText>
                                  </InputGroupAddon>
                                </InputGroup>
                              </div>
                            </div>
                          </div>
                          {iseditMode.FrameColor && <div className='parent-div'>
                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                              <ChromePicker disableAlpha={true} className='ml-2'
                                style={{ width: '240px' }}
                                color={setting.colours.frameColor}
                                onChangeComplete={(e) => {
                                  if (edit) {
                                    let colours = setting.colours;
                                    colours.frameColor = e.hex;
                                    setSetting({ ...setting, colours: colours });
                                    setEditMode({ ...iseditMode, FrameColor: false });
                                  } else setError(true);
                                }}
                              />
                            </div>
                          </div>}
                        </Colxx>
                        <Colxx xxs="6">
                          <div>
                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                              <div className='col-md-6 text-left' style={{ marginTop: '0.30rem' }}>
                                <span className=''>Bot Background Color</span>
                              </div>
                              <div className='col-md-6'>
                                <InputGroup>
                                  <Input
                                    className=""
                                    type="text"
                                    onChange={(e) => {
                                      let colours = setting.colours;
                                      colours.botBackground = e.target.value;
                                      setSetting({ ...setting, colours: colours });
                                    }}
                                    value={setting.colours.botBackground}
                                  />
                                  <InputGroupAddon addonType="append">
                                    <InputGroupText onClick={() => {
                                      setEditMode({ ...iseditMode, botBackground: !iseditMode.botBackground });
                                    }
                                    } className="color-square" style={setBackGroundColor(setting.colours.botBackground)}></InputGroupText>
                                  </InputGroupAddon>
                                </InputGroup>
                              </div>
                            </div>
                          </div>
                          {iseditMode.botBackground && <div className='parent-div'>
                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                              <ChromePicker disableAlpha={true} className='ml-2'
                                style={{ width: '240px' }}
                                color={setting.colours.botBackground}
                                onChangeComplete={(e) => {
                                  if (edit) {
                                    let colours = setting.colours;
                                    colours.botBackground = e.hex;
                                    setSetting({ ...setting, colours: colours });
                                    setEditMode({ ...iseditMode, botBackground: false });
                                  } else setError(true);
                                }}
                              />
                            </div>
                          </div>}
                        </Colxx>
                      </Row>
                      <div className='d-none my-3' style={{ justifyContent: "space-between" }}>
                        <CustomInput
                          key="isShowBot"
                          type="checkbox"
                          checked={isShowBot}
                          onChange={(e) => e.target.checked === true ? setIsShowBot(true) : setIsShowBot(false)}
                        ><span>Show Chat Only</span></CustomInput>
                      </div>
                      {/* <div className='row my-3'>
                        <div className='col-md-12'>
                          <CustomInput
                            key="isFooterBmb"
                            type="checkbox"
                            checked={isFooterHide}
                            onChange={(e) => e.target.checked === true ? setIsFooterHide(true) : setIsFooterHide(false)}
                          ><span>Remove "Empowered by Logo"</span></CustomInput>
                        </div>
                      </div> */}
                      <div className='row my-3'>
                        <div className='col-md-12'>
                          <CustomInput
                            key="isGreyScale"
                            type="checkbox"
                            checked={setting.isGreyScale}
                            onChange={(e) => handleCheckedGreyscaleButton(e)}
                          ><span>Show Powered by Logo in Greyscale</span></CustomInput>
                        </div>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
            <div className=''>
              <div className='collapse-btn border mt-0'
                onClick={() => setCollasp("avatar")}
                aria-expanded={collapse === "avatar"} >
                <h6 >Avatar
                  <i className='simple-icon-arrow-down ml-1' />
                </h6>

              </div>
              <div className="text-center">
                <Collapse className="border" isOpen={collapse === "avatar"}>
                  <Row>
                    <Colxx md={6}>
                      <b>Assistant Icon</b><br />
                      <CardImg
                        top
                        src={avatarLink}
                        alt="Card image cap"
                        className="img-thumbnail border-0 rounded-circle list-thumbnail"
                      />
                      <p style={{ color: 'gray' }}> Recommended: <br />100px X 100px</p>
                      <div className="mb-1">
                        <Button
                          color="success"
                          size="xs"
                          className="mt-1"
                          onClick={togglegallery}
                        >
                          Browse Avatars
                        </Button>
                      </div>
                    </Colxx>
                    {/* <Colxx md={6}>
                      <b>Desktop Icon</b><br />
                      <CardImg
                        style={{ maxWidth: "90px !important" }}
                        top
                        src={desktopIcon === null || desktopIcon === "" ? "https://via.placeholder.com/250x150" : desktopIcon}
                        alt="Card image cap"
                        className="img-thumbnail border-0 rounded-circle list-thumbnail mt-2 image-width"
                      />
                      <div className="mb-1">
                        <Button
                          color="success"
                          size="xs"
                          className="mt-1"
                          onClick={toggledesktopgallery}
                        >
                          Browse Image
                        </Button>
                      </div>
                    </Colxx> */}
                    <Colxx md={12}>
                      <div className="row mb-2 mt-2 text-center " style={{ margin: '0px 40px' }}>
                        <div className=" text-center col-md-6 mb-1">
                          <b>Desktop Avatar Size (px)</b>
                          <br />
                          <input
                            name="desktopAvatar"
                            type="number"
                            style={SelectStyle}
                            value={desktopAvatar}
                            min={30}
                            max={80}
                            onChange={(e) => handleAvatarSizeChange(e, 'desktop')}
                            placeholder=""
                          />
                          <p> <span style={{ color: '#A9A9A9' }}>Default: 60px</span></p>
                        </div>
                        <div className=" text-center col-md-6 mb-1">
                          <b>Mobile Avatar Size (px)</b>
                          <br />
                          <input
                            name="mobileAvatarSize"
                            type="number"
                            style={SelectStyle}
                            value={mobileAvatar}
                            min={30}
                            max={80}
                            onChange={(e) => handleAvatarSizeChange(e, 'mobile')}
                            placeholder=""
                          />
                          <p> <span style={{ color: '#A9A9A9' }}>Default: 60px</span></p>
                        </div>
                      </div>
                    </Colxx>
                  </Row>
                </Collapse>
              </div>
            </div>
            <div className=''>
              <div className='collapse-btn border mt-0' onClick={() => setCollasp("webcomponent")}
                aria-expanded={collapse === "webcomponent"} >
                <h6>Widget Components
                  <i className='simple-icon-arrow-down ml-1' />
                </h6>
              </div>
              <div className="text-center">
                <Collapse className="border" isOpen={collapse === "webcomponent"}>
                  <div className="mb-1">
                    <b>Assistant Name</b>
                    <br />
                    <input
                      name="name"
                      style={InputStlye}
                      defaultValue={assistantDetail.name}
                      placeholder={assistantDetail.name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="my-2">
                    <b>Title</b>
                    <br />
                    <input
                      name="title"
                      style={InputStlye}
                      defaultValue={assistantDetail.title}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-1">
                    <b>Subtitle</b>
                    <br />
                    <input
                      name="subTitle"
                      style={InputStlye}
                      defaultValue={assistantDetail.subTitle}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="text-left mt-4">
                    <div style={{ padding: '0 5%' }}>
                      <Row>
                        <Colxx xxs="6">
                          <div >
                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                              <div className='col-md-6 text-left' style={{
                                marginTop: '0.30rem'
                              }}><span className=''>Button Color</span></div>
                              <div className='col-md-6'>
                                <InputGroup>
                                  <Input
                                    className=""
                                    type="text"
                                    onChange={(e) => {
                                      let colours = setting.colours;
                                      colours.buttonColor = e.target.value;
                                      setSetting({ ...setting, colours: colours });
                                    }}
                                    value={setting.colours.buttonColor}
                                  />
                                  <InputGroupAddon addonType="append">
                                    <InputGroupText onClick={() => {
                                      setEditMode({ ...iseditMode, buttonColor: !iseditMode.buttonColor });
                                    }
                                    } className="color-square" style={setBackGroundColor(setting.colours.buttonColor)}></InputGroupText>
                                  </InputGroupAddon>
                                </InputGroup>
                              </div>
                            </div>
                          </div>
                          {iseditMode.buttonColor && <div className='parent-div'>
                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                              <ChromePicker disableAlpha={true} className='ml-2'
                                style={{ width: '240px' }}
                                color={setting.colours.buttonColor}
                                onChangeComplete={(e) => {

                                  if (edit) {
                                    let colours = setting.colours;
                                    colours.buttonColor = e.hex;
                                    setSetting({ ...setting, colours: colours });
                                    setEditMode({ ...iseditMode, buttonColor: false });
                                  } else setError(true);
                                }
                                }
                              />
                            </div>
                          </div>}
                        </Colxx>
                        <Colxx xxs="6">
                          <div >
                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                              <div className='col-md-6 text-left' style={{
                                marginTop: '0.30rem'
                              }}><span className=''>Button Text Color</span></div>
                              <div className='col-md-6'>
                                <InputGroup>
                                  <Input
                                    className=""
                                    type="text"
                                    onChange={(e) => {
                                      let colours = setting.colours;
                                      colours.buttonTextColor = e.target.value;
                                      setSetting({ ...setting, colours: colours });
                                    }}
                                    value={setting.colours.buttonTextColor}
                                  />
                                  <InputGroupAddon addonType="append">
                                    <InputGroupText onClick={() => {
                                      setEditMode({ ...iseditMode, buttonTextColor: !iseditMode.buttonTextColor });
                                    }
                                    } className="color-square" style={setBackGroundColor(setting.colours.buttonTextColor)}></InputGroupText>
                                  </InputGroupAddon>
                                </InputGroup>
                              </div>
                            </div>
                          </div>
                          {iseditMode.buttonTextColor && <div className='parent-div'>
                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                              <ChromePicker disableAlpha={true} className='ml-2'
                                style={{ width: '240px' }}
                                color={setting.colours.buttonTextColor}
                                onChangeComplete={(e) => {
                                  if (edit) {
                                    let colours = setting.colours;
                                    colours.buttonTextColor = e.hex;
                                    setSetting({ ...setting, colours: colours });
                                    setEditMode({ ...iseditMode, buttonTextColor: false });
                                  } else setError(true);
                                }}
                              />
                            </div>
                          </div>}
                        </Colxx>
                      </Row>
                    </div>
                    <div style={{ padding: '0 5%' }}>
                      <div className='row my-3'>
                        <div className='col-md-12'>
                          <CustomInput
                            key="isBookingButtonHide"
                            type="checkbox"
                            checked={setting.isBookingButtonHide}
                            onChange={(e) => handleCheckedBookingButton(e)}
                          ><span>Hide Booking Engine Button</span></CustomInput>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-md-12'>
                          <CustomInput
                            key="isShowCookies"
                            type="checkbox"
                            checked={setting.cookiesSetting.isShowCookies}
                            onChange={(e) => handleChangeCookies(e)}
                          ><span>Show Privacy/Cookies popup</span></CustomInput>
                        </div>
                        {setting.cookiesSetting !== null && setting.cookiesSetting.isShowCookies &&
                          <div className='col-md-12'>
                            <ReactQuill
                              theme="snow"
                              value={getLocalStatement(setting.cookiesSetting.text)}
                              onChange={(content, delta, source) =>
                                handleChangeCookiesText(source, content)
                              }
                              modules={quillModules}
                              formats={quillFormats}
                              name="text"
                            />
                          </div>
                        }
                      </div>
                      <div className='row my-3'>
                        <div className='col-md-12  mb-2'>
                          <CustomInput
                            key="isBookNowButton"
                            type="checkbox"
                            checked={setting.isBookNowButton}
                            onChange={(e) => handleCheckedBookNowButton(e)}
                          ><span>Show Book Now Button</span></CustomInput>
                        </div>
                        <div className='col-md-6'>
                          <b>Book Now Button Text</b>
                          <br />
                          <Input
                            className=" mt-2"
                            type="text"
                            name="bookNowButtonText"
                            value={setting.bookNowButtonText}
                            onChange={(e) => handleChangeBookNowButtonText(e)}
                          ></Input>
                        </div>
                        <div className='col-md-6'>
                          <b>Book Now Button Url</b>
                          <br />
                          <Input
                            className=" mt-2"
                            type="text"
                            name="bookNowButtonUrl"
                            value={setting.bookNowButtonUrl}
                            onChange={(e) => handleChangeBookNowButtonText(e)}
                          ></Input>
                        </div>
                      </div>
                      <Separator className="mb-3 mt-3" />
                      <Row>
                        <Colxx md={12}>
                          <div className='row my-3'>
                            <div className='col-md-12'>
                              <CustomInput
                                key="isMicIcon"
                                type="checkbox"
                                checked={setting.isMicIcon}
                                onChange={(e) => handleCheckedMicIcon(e)}
                              ><span>Enable Voice Input</span></CustomInput>
                            </div>
                          </div>
                        </Colxx>
                        <Colxx md={12} className="text-center">
                          <b>Voice Icon</b><br />
                          <CardImg
                            top
                            src={voiceIcon === null || voiceIcon === "" ? "https://via.placeholder.com/250x150" : voiceIcon}
                            alt="Card image cap"
                            className="img-thumbnail border-0 rounded-circle list-thumbnail"
                          />
                          <div className="mb-1">
                            <Button
                              color="success"
                              size="xs"
                              className="mt-1"
                              onClick={toggleVoicegallery}
                            >
                              Browse Mic Icon
                            </Button>
                          </div>
                        </Colxx>
                        <Colxx md="6">
                          <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                            <div className='col-md-6 text-left' style={{
                              marginTop: '0.30rem'
                            }}><span className=''>Mic Icon Color</span></div>
                            <div className='col-md-6'>
                              <InputGroup>
                                <Input
                                  className=""
                                  type="text"
                                  onChange={(e) => {
                                    let colours = setting.colours;
                                    colours.micColor = e.target.value;
                                    setSetting({ ...setting, colours: colours });
                                  }}
                                  value={setting.colours.micColor}
                                />
                                <InputGroupAddon addonType="append">
                                  <InputGroupText onClick={() => {
                                    setEditMode({ ...iseditMode, micColor: !iseditMode.micColor });
                                  }
                                  } className="color-square" style={setBackGroundColor(setting.colours.micColor)}></InputGroupText>
                                </InputGroupAddon>
                              </InputGroup>
                            </div>
                          </div>
                          {iseditMode.micColor && <div className='parent-div'>
                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                              <ChromePicker disableAlpha={true} className='ml-2'
                                style={{ width: '240px' }}
                                color={setting.colours.micColor}
                                onChangeComplete={(e) => {
                                  if (edit) {
                                    let colours = setting.colours;
                                    colours.micColor = e.hex;
                                    setSetting({ ...setting, colours: colours });
                                    setEditMode({ ...iseditMode, micColor: false });
                                  } else setError(true);
                                }}
                              />
                            </div>
                          </div>}
                        </Colxx>
                      </Row>
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
            <div className=''>
              <div className='collapse-btn border mt-0' onClick={() => setCollasp("suggestions")}
                aria-expanded={collapse === "suggestions"}
              >
                <h6>Suggestions
                  <i className='simple-icon-arrow-down ml-1' />
                </h6>
              </div>
              <div className='text-center'>
                <Collapse className="border" isOpen={collapse === "suggestions"}>
                  <div className="text-left mt-4">
                    <div style={{ padding: '0 5%' }}>
                      <Row>

                        {/* Image upload (below Suggestions) */}
                        <Colxx md={12} className="mb-2">
                          <Label>Background Image</Label>
                          <div className="text-center form-control">
                            {suggestionBot.backgroundImage ? (
                              <div className="thumbnail">
                                <img
                                  className="list-thumbnail responsive border-0"
                                  src={suggestionBot.backgroundImage}
                                  alt=""
                                />
                                <a
                                  href="#/"
                                  className="remove"
                                  data-dz-remove
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleRemoveSuggestionImage();
                                  }}
                                >
                                  <i className="glyph-icon simple-icon-trash" />
                                </a>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                          <Button
                            color="secondary"
                            className="mt-1 btn-sec"
                            onClick={toggleSuggestionGallery}
                          >
                            <IntlMessages id='dashboards.browsegallery' />
                          </Button>
                        </Colxx>
                        <Colxx md={12} className="mb-2">
                          <Label>Hero Message</Label>
                          <Input
                            type="textarea"
                            name="text"
                            value={getLocalStatement(suggestionBot.message)}
                            onChange={event => handleSuggestionTextChange(event)}
                          />
                        </Colxx>
                        <Colxx md={12} className="mb-2">
                          <Label>Typing Placeholder Text</Label>
                          <Input
                            type="text"
                            name="text"
                            value={getLocalStatement(suggestionBot.placeHolderText)}
                            onChange={event => handleSuggestionPlaceholderTextChange(event)}
                          />
                        </Colxx>
                        <Colxx md={12} className="mb-3">
                          <Label>Select Properties for Suggestions</Label>
                          <Select
                            isMulti
                            options={propertyOptions}
                            value={selectedProperties}
                            onChange={(val) => {
                              const selected = val || [];
                              setSelectedProperties(selected);
                              setPropertyButtonsData(prev => {
                                const updated = {};

                                selected.forEach(p => {
                                  updated[p.value] = prev[p.value] || [];
                                });

                                return updated;
                              });
                            }}
                          />
                        </Colxx>
                        <Colxx md={12}>
                          <Label>Default Suggestions</Label>
                          {renderButtonsSection(
                            suggestionBot.buttons || [],
                            (updated) =>
                              setsuggestionBot(prev => ({
                                ...prev,
                                buttons: updated
                              }))
                          )}

                          {selectedProperties?.map((prop) => {
                            const propertyId = prop.value;
                            const propertyName = prop.label;

                            const buttons = propertyButtonsData[propertyId] || [];
                            const isSelected = selectedProperties.some(p => p.value === propertyId);

                            if (!buttons.length && !propertyButtonsData[propertyId]) return null;

                            return (
                              <div key={propertyId} className="mt-4">
                                <Separator className="my-3" />

                                <Label>
                                  Property: {propertyName}{' '}
                                  <span className="text-muted">({propertyId})</span>
                                </Label>

                                {renderButtonsSection(
                                  buttons,
                                  (updated) => {
                                    setPropertyButtonsData(prev => {
                                      const newData = { ...prev };

                                      if (!updated.length) {
                                        delete newData[propertyId];
                                      } else {
                                        newData[propertyId] = updated;
                                      }

                                      return newData;
                                    });
                                  }
                                )}
                              </div>
                            );
                          })}

                        </Colxx>
                      </Row>
                    </div>
                  </div>
                </Collapse>
              </div>
            </div >
            {/* <Separator className="my-2 mt-4"></Separator> */}
            < div className='text-center' >
              <div className="mb-2 " style={{ marginTop: '40px' }}>
                <Button color="primary" size="xs" onClick={handleSave}>
                  <IntlMessages id='dashboards.save' />
                </Button>
                <Button
                  size="xs"
                  color="secondary"
                  className='ml-2'
                  onClick={() => {
                    CloseColorBox();
                  }}
                >
                  <IntlMessages id='pages.cancel' />
                </Button>
              </div>
            </div >
          </CardBody >
        </Card >
      ) : null
      }
      {ImageGalleryButton()}
      {ImageDesktopGalleryButton()}
      {ImageMicIconButton()}
      {/* Suggestions image gallery */}
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={suggestionGalleryVisible}
                toggle={toggleSuggestionGallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={toggleSuggestionGallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    propertyId={propertyId}
                    selectedImage={selectedSuggestionImage}
                    togglegallery={toggleSuggestionGallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>

    </Fragment >
  );
}

export const sortPropertyListByName = (list) => {
  return list.sort(function (a, b) {
    if (a.name < b.name) { return -1; } if (a.name > b.name) { return 1; } return 0;
  }).sort((a, b) => a.name - b.name);
};